export default __webpack_public_path__ + "static/media/fMaltoBuza39.30a76da9.png";